/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react'
import * as echarts from 'echarts'

const Bar = function ({
  id,
  width,
  height,
  colors = [],
  xAxisData = [],
  yAxisData = [],
  seriesData = [],
  dataZoom = { show: false, orient: 'horizontal' },
  // interval = 0,
  type = 'vertical',
  axisLabel = {},
}) {
  useEffect(() => {
    const chartDom = document.getElementById(id)
    const myChart = echarts.init(chartDom)
    myChart.setOption({
      color: colors,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
        },
      },
      grid: {},
      legend: {
        type: 'scroll',
        right: 0,
        itemWidth: 14,
        itemHeight: 14,
        itemLineHeight: 14,
        textStyle: {
          fontSize: 14,
          // color: 'rgba(234, 237, 255, 0.9)',
          color: 'var(--ow-color-primary-700)',
        },
        data: seriesData.map((d) => {
          return d.name
        }),
      },
      xAxis: [
        {
          type: type === 'vertical' ? 'category' : 'value',
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              // color: '#272C46',
              width: 1,
            },
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            rotate: 0,
            interval: 0,
            linStyle: {
              color: '#fff',
            },
            textStyle: {
              // color: '#EAEDFF',
              fontSize: 12,
            },
            ...axisLabel,
          },
          data: xAxisData,
        },
      ],
      dataZoom: [
        {
          // type: 'slider',
          // xAxisIndex: [0],
          // start: 80,
          // end: 100, // 初始化滚动条
          ...dataZoom,
        },
      ],
      yAxis: {
        type: type === 'vertical' ? 'value' : 'category',
        axisLabel: {
          // color: '#EAEDFF',
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#272C46',
          },
        },
        data: yAxisData,
      },
      series: seriesData,
    })
  }, [id, seriesData])
  return <div id={id} style={{ width, height }} />
}

export default Bar
